import { render, staticRenderFns } from "./Nation.vue?vue&type=template&id=aa86494c&scoped=true"
import script from "./Nation.vue?vue&type=script&lang=js"
export * from "./Nation.vue?vue&type=script&lang=js"
import style0 from "./Nation.vue?vue&type=style&index=0&id=aa86494c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa86494c",
  null
  
)

export default component.exports